import { FC } from "react"
import styled from "styled-components"

import { useProductRecommendations } from "@hooks/index"

import { ProductThumbnail, SectionWithTitle } from "@components/ui"
import { ContentfulProductWithShopifyData } from "@lib/types"

interface Props {
  productId: string
}

export const ProductRecommendations: FC<Props> = ({ productId }) => {
  const { productRecommendations } = useProductRecommendations(productId)

  const prepareProps = productRecommendations?.map((pr: any) => {
    if(!pr.availableForSale) return;
    return {
      ...pr,
      shopifyProduct: pr,
    }
  })

  return (
    <SectionWithTitle
      title="People also bought"
      preTitle="Related Products"
      backgroundColor={{ name: "white", value: "#FFF" }}
    >
      <ProductList>
        {prepareProps
          ?.slice(0, 4)
          ?.map((product: ContentfulProductWithShopifyData) => (
            <ProductThumbnail key={product.id} product={product} />
          ))}
      </ProductList>
    </SectionWithTitle>
  )
}

const ProductList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2.7rem 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    margin: 0 auto;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2.5rem;
    width: 100%;
    max-width: 109rem;
  }
`
